export const VERSION = '3.0.0-beta.5';
